module.exports = require("redux-logger");


//////////////////
// WEBPACK FOOTER
// external "redux-logger"
// module id = 27
// module chunks = 0